var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:{ 'btn-two-rows': _setup.isMobile },attrs:{"color":"success","loading":_setup.isPending,"disabled":_vm.disabled},on:{"click":function($event){return _setup.mutate({ bookingId: _vm.bookingId })}}},[_vm._v(" Skicka tillvalsmejl ")])
}
var staticRenderFns = []

export { render, staticRenderFns }